
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/cart",
      function () {
        return require("private-next-pages/[domain]/cart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/cart"])
      });
    }
  